import { collection, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import {
  STREET_SURVEY_TEMPLATES_COLLECTION,
  type StreetSurveyTemplate,
} from '@citizen-walk/shared-types';
import { db } from '../../lib/firebase';

export type StreetSurveyTemplateOption = StreetSurveyTemplate & { id: string };

/**
 * 地区に適用できる机上調査テンプレートの一覧 (docs/27 §17-4、アーカイブ済みを除く)。
 * マスタ画面の hook (features/masters) は画面一式を読み込むため、机上調査ページでは直接購読する。
 */
export function useStreetSurveyTemplateOptions(enabled: boolean): StreetSurveyTemplateOption[] {
  const [items, setItems] = useState<StreetSurveyTemplateOption[]>([]);
  useEffect(() => {
    if (!enabled) return;
    return onSnapshot(
      collection(db, STREET_SURVEY_TEMPLATES_COLLECTION),
      (snap) =>
        setItems(
          snap.docs
            .map((d) => ({ ...(d.data() as StreetSurveyTemplate), id: d.id }))
            .filter((t) => !t.archivedAt)
            .sort((a, b) => (a.displayName ?? '').localeCompare(b.displayName ?? '', 'ja')),
        ),
      () => setItems([]),
    );
  }, [enabled]);
  return items;
}
